import { useRequest } from '@pb/utils'
import { path } from 'ramda'

/*
 * useHTML :: (endpoint, cssSelector (optional)) -> { isLoading, error, data }
 * */

const useHTML = (endpoint: string, cssSelector?: any): any => {
  const { data, loading, error } = useRequest(endpoint, {
    use: {
      apiVersion: false,
    },
  })

  const getHTMLBySelector = (): any => {
    const elt = document.createElement('div')
    elt.innerHTML = data
    return path(['innerHTML'], elt.querySelector(cssSelector))
  }

  return {
    data: cssSelector ? getHTMLBySelector() : data,
    isLoading: loading,
    error,
  }
}

export default useHTML
